import { createContext, useContext } from "react";
import { useApi } from "@/hooks/useApi";

const SiteContext = createContext(null);

export const SiteProvider = ({ children }) => {
  const state = useApi("/site");
  return <SiteContext.Provider value={state}>{children}</SiteContext.Provider>;
};

export const useSiteState = () => useContext(SiteContext);
export const useSite = () => useContext(SiteContext)?.data;

export const useMedia = (filename) => {
  const site = useSite();
  return filename ? site?.media?.[filename] : undefined;
};
